import BaseAPI from "../api";
const path:string = "province";

export class ProvinceAPI extends BaseAPI{
    static GetProvince():Promise<any>{
        return this.api.get(`${path}`)
    }

}